<template>
  <div
    class="offer-card"
    :class="[ candidate.status === 'New' ? 'new-candidate' : '' ]"
    @click="openCandidate"
  >
    <div class="row">
      <div
        v-if="candidate.isExternal"
        class="external-candidate"
      >
        <font-awesome-icon icon="external-link-square-alt" />
      </div>
      <!-- Candidate Col -->
      <div class="col-12 col-md-3">
        <h1
          v-if="candidate && candidate.user"
          class="title"
        >
          {{ candidate.user.first_name }} {{ candidate.user.last_name }}
        </h1>
        <h1
          v-if="candidate && candidate.user && candidate.user.city && candidate.user.zip"
          class="company"
        >
          {{ candidate.user.city }}, {{ candidate.user.zip }}
        </h1>
        <div class="sm-text">
          <p
            v-if="candidate && candidate.user && !candidate.user.email"
            class="m-0"
            style="font-size: 0.9rem"
          >
            <font-awesome-icon
              icon="mail-bulk"
            />
            {{ $t('generic.hidden-contact-details', 'Contact details hidden') }}
          </p>
          <div v-else>
            <p
              v-if="candidate && candidate.user"
              class="m-0"
            >
              <font-awesome-icon
                icon="envelope"
              />
              {{ candidate.user.email }}
            </p>
            <p
              v-if="candidate && candidate.user && candidate.user.phone"
              class="m-0"
            >
              <font-awesome-icon
                icon="phone"
              />
              {{ candidate.user.phone }}
            </p>
          </div>
        </div>
        <div class="sm-text">
          <font-awesome-icon
            icon="clock"
          />
          {{ shortApplicationDate }}
        </div>
      </div>
      <!-- Status and date Col -->
      <div class="col-12 col-md-4">
        <div class="text-center pt-2">
          <div class="sm-text">
            <div>{{ $t('cards.offer-candidate.last-status-change', 'Last status change') }}:</div>
            <font-awesome-icon
              icon="clock"
            /> {{ candidate.updated_at }}
          </div>
          <div
            v-if="candidate"
            class="ml-3 sm-text cursor-pointer"
          >
            <font-awesome-icon
              v-if="candidate.status === 'New'"
              class="mr-2 icon"
              icon="eye-slash"
            />
            <font-awesome-icon
              v-if="candidate.status === 'Seen'"
              class="mr-2 icon"
              icon="hourglass"
            />
            <font-awesome-icon
              v-if="candidate.status === 'In process'"
              class="mr-2 icon"
              icon="tasks"
            />
            <font-awesome-icon
              v-if="candidate.status === 'Accepted'"
              class="mr-2 icon"
              icon="user-check"
            />
            <font-awesome-icon
              v-if="candidate.status === 'Rejected'"
              class="mr-2 icon"
              icon="user-times"
            />
            <font-awesome-icon
              v-if="candidate.status === 'Invalid'"
              class="mr-2 icon"
              icon="user-slash"
            />
            {{ candidateStatus }}
          </div>
        </div>
      </div>
      <!-- Offer Col -->
      <div class="col-12 col-md-4">
        <h1 class="title">
          {{ shortOfferTitle }}
        </h1>
        <h1 class="company">
          <span v-if="candidate.offer.companyHideName === 0">
            {{ candidate.offer.user.company.title }}
          </span>
          <span
            v-if="candidate.offer.companyHideName === 1"
            style="color: #666; text-transform: initial; font-size: 0.8rem;"
          >
            {{ $t('generic.hidden-company-name', 'Company name not available') }}
          </span>
        </h1>
        <h1 class="municipality">
          {{ candidate.offer.locationProvince }}, {{ candidate.offer.locationMunicipality }} ( {{ candidate.offer.locationCountry }} )
        </h1>
        <div class="sm-text">
          <font-awesome-icon
            icon="clock"
          />
          {{ shortOfferDate }}
        </div>
      </div>
      <div
        v-if="isDelegation"
        class="col-1 m-auto"
      >
        <b-button
          size="sm"
          @click.stop="$emit('cancelDelegation', candidate.id)"
        >
          {{ $t('generic.delete') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    candidate: {
      type: Object,
      default: null
    },
    isDelegation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    candidateStatus() {
      if (this.candidate && this.candidate.status) {
        return this.$t(`generic.${this.candidate.status.toLowerCase().replace(/\s/g,'')}`, this.candidate.status);
      }
      return '';
    },
    shortOfferTitle() {
      let title = this.candidate.offer.titleTitle.substring(0, 35);
      if(this.candidate.offer.titleTitle.length > 35) {
        title += "..."
      }
      return title;
    },
    shortOfferDate() {
      return this.candidate.offer.created_at.substring(0, 10);
    },
    shortApplicationDate() {
      return this.candidate.created_at.substring(0, 10);
    }
  },
  watch: {
    candidate: {
      handler(val) {
        if (!val.user && val.external_candidate) {
          val.user = val.external_candidate;
          val.isExternal = true;
        }
      },
      deep: true
    }
  },
  created() {
      if (!this.candidate.user && this.candidate.external_candidate) {
        this.candidate.user = this.candidate.external_candidate;
        this.candidate.isExternal = true;
      }
  },
  methods: {
    showCV() {
      window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/cv/' + this.candidate.cv);
    },
    openCandidate() {
      if (!this.candidate.isExternal) {
        this.$router.push({ path: '/jobs/candidate/' + this.candidate.id })
      } else {
        this.$router.push({ path: '/jobs/external-candidate/' + this.candidate.id })
      }
    }
  }
}
</script>


<style scoped lang="scss">
  .offer-card {
    cursor: pointer;
    background: white;
    padding: 10px 25px;
    margin-bottom: 1rem;
    transition: 0.3s ease;

    &:hover {
      box-shadow: 3px 3px 20px 0px rgba(210,210,210,1);
    }
  }

  h1.title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
  }

  h1.company {
    color: #009090;
    font-size: 0.9rem !important;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  .sm-text {
    font-size: 0.9rem;
    color: #666;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .new-candidate {
    background: #f7fff7;
  }

  h1.municipality {
    color: #777;
    font-size: 0.8rem !important;
    margin-bottom: 0;
  }

  .external-candidate {
    position: absolute;
    transform: translate(-15px, -15px);
  }
</style>
